export class LoginScreenSettings {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a, _b, _c;
        this.isEnabled = model.isEnabled;
        this.title = (_a = model.title) !== null && _a !== void 0 ? _a : undefined;
        this.color = (_b = model.color) !== null && _b !== void 0 ? _b : undefined;
        this.logoUrl = (_c = model.logoUrl) !== null && _c !== void 0 ? _c : undefined;
        this.isGoogleEnabled = model.isGoogleEnabled;
        this.isEmailEnabled = model.isEmailEnabled;
        this.isSsoEnabled = model.isSsoEnabled;
    }
}
